module.exports = __webpack_public_path__ + "media/images/advisor/img_7_1-2aeb03112cffc5efbb5bea55359c46a0.png";